"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUpIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const ArrowUp = props => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("polygon", { points: "8.00000021 0 2 6.26026805 3.27292822 7.58841332 7.1513814 3.54172071 7.1513814 16 8.84861903 16 8.84861903 3.54172071 12.7270718 7.58841332 14 6.26026805" }, void 0) }), void 0));
exports.ArrowUpIcon = (0, makeIcon_1.makeIcon)('arrowUp')(ArrowUp);
//# sourceMappingURL=ArrowUp.js.map